<template>
  <div>

      <div class="loading"></div>
      <div class="spin">
        <span class="text-center">
          <div id="sireh-spiner-full" style="height: 150px"></div>
          <strong>{{ msj }}</strong>
        </span>
      </div>

  </div>
</template>
<script>
import lottieWeb from "lottie-web";
export default {
  props: ["tipo", "msj","idSpinner"],
  components: {
    lottieWeb,
  },
  data() {
    return {
    };
  },
  methods: {
   
  },
  created() {},
  mounted() {
    var animation = lottieWeb.loadAnimation({
        container: document.getElementById("sireh-spiner-full"),
        path: `LoaderSIAHE.json`, 
        renderer: "svg",
        loop: true,
        autoplay: true,
        name: "Animación",
      });
      animation.goToAndStop(50, true);
  },
};
</script>
<style scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: grey;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  opacity: 0.5;
  min-height: calc(100vh - 56px);
}
.spin {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001;
  min-height: calc(100vh - 56px);
  max-width: 100%;
}

/*.kuramaSpinner {
  display: inline-grid;
  width: 20px;
  height: 20px;
  position: fixed;
  left: 50%;
  top: 10%;
}*/

div.kuramaDiv img.izquierda {
  float: center;

}

div.reset {
  clear: both;
}

</style>